/* One page control, yielding to an active guide's own reading-progress control. */
(() => {
  if (window.BKScrollTop) return;
  window.BKScrollTop = true;
  let frame = 0;
  const bound = new WeakSet();
  const visible = element => {
    if (!element || element.hidden || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };
  const update = () => {
    frame = 0;
    const buttons = [...document.querySelectorAll('[data-bk-scroll-top]')];
    const button = buttons[0];
    if (!button) return;
    for (const control of buttons) {
      if (bound.has(control)) continue;
      bound.add(control);
      // Native predictive search cancels every document keyup, including Space.
      // Keep the button's standard keyboard activation inside this control.
      control.addEventListener('keyup',event => event.stopPropagation());
    }
    buttons.slice(1).forEach(extra => { extra.hidden = true; });
    const ownReader = [...document.querySelectorAll('[data-guide-top],[data-school-back-top],.atlas-back-top,.bk-scent-top')].some(visible);
    const dialog = [...document.querySelectorAll('dialog[open],.dlg,.pswp.pswp--open,#bls-header_minicart.bls__opend-popup-header,#ba-cookie-bar,#ba-cookie-box,.cookie-banner')].some(visible);
    const blocked = dialog || document.body.classList.contains('overflow-hidden') || document.body.classList.contains('menu-open');
    const length = Math.max(0, document.documentElement.scrollHeight - innerHeight);
    button.hidden = scrollY <= 400 || !length || ownReader || blocked;
    const value = Math.round(Math.max(0,Math.min(100,scrollY / Math.max(1,length) * 100)));
    button.style.setProperty('--scroll-top-progress',String(value));
    button.querySelector('[data-scroll-top-percent]').textContent = `${value}%`;
    // Clear the native mobile navigation, purchase bar and Shopify preview bar.
    let inset = 24;
    for (const overlay of document.querySelectorAll('.bls__mobile-stickybar,[data-purchase-bar],#PBarNextFrame')) {
      if (!visible(overlay)) continue;
      const box = overlay.getBoundingClientRect();
      if (box.top < innerHeight && box.bottom >= innerHeight - 2) inset = Math.max(inset, innerHeight - box.top + 14);
    }
    button.style.setProperty('--scroll-top-bottom',`${inset}px`);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-bk-scroll-top]');
    if (!button) return;
    event.preventDefault();
    const main = document.querySelector('#MainContent,main');
    if (main) {
      const previous = main.getAttribute('tabindex');
      main.tabIndex = -1;
      main.focus({preventScroll:true});
      main.addEventListener('blur',() => {
        if (previous === null) main.removeAttribute('tabindex');
        else main.setAttribute('tabindex',previous);
      },{once:true});
    }
    window.scrollTo({top:0,left:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  });
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule);
  addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  const resize = new ResizeObserver(schedule);
  resize.observe(document.documentElement);
  // Guide-ready, overlay and native-bar state may change without scrolling.
  new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('[data-bk-scroll-top]'))) schedule();
  }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden','open']});
  schedule();
})();
